export default function OutOfStockSlash({
  containerClassName,
  svgClassName,
  viewBox = '0 0 100 100',
  x1 = '0',
  y1 = '0',
  x2 = '100',
  y2 = '100'
}) {
  const slash = (
    <svg
      className={svgClassName}
      viewBox={viewBox}
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <line
        x1={x1}
        y1={y1}
        x2={x2}
        y2={y2}
        strokeWidth="2"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );

  if (!containerClassName) {
    return slash;
  }

  return <div className={containerClassName}>{slash}</div>;
}
